<template>
  <div class="row">
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs" v-model="tabsActive">
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      @exibirVermelhos="handleExibirVermelhos"
                      @exibirVerdes="handleExibirVerdes"
                      :setColor="setColor"
                      @resetColor="resetColor"
                      :setRed="exibirCadastrosVermelhos"
                      :setGreen="exibirCadastrosVerdes"
                    ></Subtitle>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="familias-visitadas"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros-vuetfy
                  ref="table"
                  :cadastros="displayedCadastros"
                  :data_secretaria_de_saude="data_secretaria_de_saude"
                  :loading="loading"
                  texto_esus_pec="Visitas registradas até"
                  :data_esus_pec="data_secretaria_de_saude"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros-vuetfy>
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab title="Resultado">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Resultado
          </template>
          <div class="row">
            <div class="col-md-12">
              <div class="box">
                <div class="box-header">
                  <h4 class="box-title">
                    <i class="icofont-listine-dots"></i> Secretaria Municipal de
                    Saúde
                  </h4>
                </div>
                <div class="box-body">
                  <table
                    class="table table-responsive table-bordered text-center table2"
                    id="table"
                  >
                    <thead>
                      <tr>
                        <th>Por</th>
                        <th>Total</th>
                        <th>
                          A visitar / Dia
                          <span
                            v-b-tooltip.hover
                            title="Estimativa para visitar todas as famílias em 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Menos de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Famílias visitadas no últimos 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                        <th>
                          Mais de 30 dias
                          <span
                            v-b-tooltip.hover
                            title="Famílias visitadas há mais de 30 dias"
                            class="icon-tooltip"
                          >
                            <i class="icofont-info-circle"></i>
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Município</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              secretaria_municipal_de_saude_total_no_municipio
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                secretaria_municipal_de_saude_total_no_municipio /
                                  21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${(
                                  (secretaria_municipal_de_saude_total_no_municipio /
                                    100) *
                                  secretaria_municipal_de_saude_no_municipio_atualizados
                                ).toFixed(0)}

                                (${secretaria_municipal_de_saude_no_municipio_atualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                ${(
                                  (secretaria_municipal_de_saude_total_no_municipio /
                                    100) *
                                  secretaria_municipal_de_saude_no_municipio_desatualizados
                                ).toFixed(0)}

                                (${secretaria_municipal_de_saude_no_municipio_desatualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr>
                        <td>Equipe</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              secretaria_municipal_de_saude_total_na_equipe
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                secretaria_municipal_de_saude_total_na_equipe /
                                  21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                ${(
                                  (secretaria_municipal_de_saude_total_na_equipe /
                                    100) *
                                  secretaria_municipal_de_saude_na_equipe_atualizados
                                ).toFixed(0)}

                                (${secretaria_municipal_de_saude_na_equipe_atualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                  ${(
                                    (secretaria_municipal_de_saude_total_na_equipe /
                                      100) *
                                    secretaria_municipal_de_saude_na_equipe_desatualizados
                                  ).toFixed(0)}
                                  (${secretaria_municipal_de_saude_na_equipe_desatualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                      <tr>
                        <td>ACS</td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="secretaria_municipal_de_saude_total_no_acs"
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center font-weight-bold">
                          <loader
                            :value="
                              Math.round(
                                secretaria_municipal_de_saude_total_no_acs / 21
                              )
                            "
                            :loading="loading"
                          ></loader>
                        </td>
                        <td class="text-center green font-weight-bold">
                          <loader
                            :value="`
                                  ${(
                                    (secretaria_municipal_de_saude_total_no_acs /
                                      100) *
                                    secretaria_municipal_de_saude_no_acs_atualizados
                                  ).toFixed(0)}
                                  (${secretaria_municipal_de_saude_no_acs_atualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                        <td class="text-center red font-weight-bold">
                          <loader
                            :value="`
                                  ${(
                                    (secretaria_municipal_de_saude_total_no_acs /
                                      100) *
                                    secretaria_municipal_de_saude_no_acs_desatualizados
                                  ).toFixed(0)}
                                  (${secretaria_municipal_de_saude_no_acs_desatualizados}%)`"
                            :loading="loading"
                            :isPercentage="false"
                          ></loader>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <FonteEsusPecGlobal
                    texto="Visitas registrados até"
                    :data="data_secretaria_de_saude"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions.js'
import TabelaCadastrosVuetfy from './TabelaCadastrosVuetfy.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'FamiliasVisitadas',
  components: {
    PulseLoader,
    Loader,
    Subtitle,
    TabelaCadastrosVuetfy,
    DownloadFiles,
  },
  data() {
    return {
      tabsActive: 0,
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipes: '',
      equipe: '',
      profissionais: '',
      profissional: '',
      visibleDataAcs: false,
      cadastros: [],
      page: 1,
      perPage: 10,
      pages: [],
      idade_inicial: '',
      idade_final: '',
      data_ministerio_da_saude: null,
      populacaoIbge: 0,
      totalCadastrosMunicipio: 0,
      totalCadastrosEquipe: '',
      parametro: '',
      diferencaDeCadastros: '',
      diferenca_no_municipio: '',
      resultado_no_municipio: '',
      diferenca_na_equipe: '',
      resultado_na_equipe: '',
      total_de_registros_da_tabela: 0,
      secretaria_municipal_de_saude_total_no_municipio: 0,
      secretaria_municipal_de_saude_no_municipio_atualizados: 0,
      secretaria_municipal_de_saude_no_municipio_desatualizados: 0,
      secretaria_municipal_de_saude_total_na_equipe: 0,
      contOkNaEquipe: 0,
      contFANaEquipe: 0,
      secretaria_municipal_de_saude_na_equipe_atualizados: 0,
      secretaria_municipal_de_saude_na_equipe_desatualizados: 0,
      contOKAcs: 0,
      contFAAcs: 0,
      secretaria_municipal_de_saude_total_no_acs: 0,
      secretaria_municipal_de_saude_no_acs_atualizados: 0,
      secretaria_municipal_de_saude_no_acs_desatualizados: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      nomeEquipe: '',
      dadosDoResultado: [],
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      setColor: null,
      cadastrosOriginais: [],
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
    data_secretaria_de_saude() {
      return this.$store.getters['getUltimaAtualizacao']
        .split('/')
        .reverse()
        .join('-')
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
    async filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data, this.data_secretaria_de_saude)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data, this.data_secretaria_de_saude)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
      this.cadastros = data
    },
    resetColor() {
      this.setColor = false
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
    },
    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = false
      }
    },

    // Busca os dados referentes a cidade ao abrir a página
    async buscarDadosIniciais() {
      this.setColor = true
      this.tabsActive = 0
      try {
        this.loading = true

        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.cod_ibge,
          id: this.user_id,
        })
        if (user) {
          //pega a equipe do acs
          let equipe = await this.$api.get(
            '/app/equipe/' + user.data.cod_ibge + '/' + user.data.nu_ine
          )
          if (equipe) {
            this.equipe = equipe.data.nu_ine
            this.nomeEquipe = equipe.data.no_equipe

            let response = await this.$api.get(
              '/app/indicadores-aps/resultado/' + this.cod_ibge + '/21'
            )
            if (response) {
              this.dadosDoResultado = response.data
              // dados do município
              const dadosDoMunicipio = response.data.find((item) => {
                return item.ibge_ine === 'MUN'
              })
              this.secretaria_municipal_de_saude_total_no_municipio = parseInt(
                dadosDoMunicipio.denominador
              )
              this.secretaria_municipal_de_saude_no_municipio_atualizados =
                dadosDoMunicipio.resultado
              this.secretaria_municipal_de_saude_no_municipio_desatualizados =
                100 -
                parseInt(
                  this.secretaria_municipal_de_saude_no_municipio_atualizados
                )

              // dados da equipe
              const dadosDaEquipe = this.dadosDoResultado.find((item) => {
                return item.ibge_ine === this.equipe
              })
              this.secretaria_municipal_de_saude_total_na_equipe = parseInt(
                dadosDaEquipe.denominador
              )
              this.secretaria_municipal_de_saude_na_equipe_atualizados =
                parseInt(dadosDaEquipe.resultado)
              this.secretaria_municipal_de_saude_na_equipe_desatualizados =
                100 -
                parseInt(
                  this.secretaria_municipal_de_saude_na_equipe_atualizados
                )

              this.carregarCadastrosIndividuais()
            }
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async carregarCadastrosIndividuais() {
      try {
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.cod_ibge,
          id: this.user_id,
        })
        if (user) {
          // dados do acs
          const dadosDoAcs = this.dadosDoResultado.find((item) => {
            return item.ibge_ine === user.data.cpf
          })
          this.secretaria_municipal_de_saude_total_no_acs = parseInt(
            dadosDoAcs.denominador
          )
          this.secretaria_municipal_de_saude_no_acs_atualizados = parseInt(
            dadosDoAcs.resultado
          )
          this.secretaria_municipal_de_saude_no_acs_desatualizados =
            100 -
            parseInt(this.secretaria_municipal_de_saude_no_acs_atualizados)

          let familias_visitadas = await this.$api.get(
            '/app/familias-visitadas/' +
              user.data.cod_ibge +
              '/' +
              user.data.cpf
          )
          if (familias_visitadas) {
            this.cadastrosOriginais = familias_visitadas.data
            this.cadastros = familias_visitadas.data
            this.total_de_registros_da_tabela = familias_visitadas.data.length
            this.loading = false
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    corTextoDiferenca(valor) {
      if (valor >= 0) {
        return 'green'
      } else {
        return 'red'
      }
    },

    corTextoResultado(valor) {
      if (valor >= 70) {
        return 'green'
      } else {
        return 'red'
      }
    },

    corTextoResultadoNaEquipe(valor) {
      if (valor >= 100) {
        return 'green'
      } else {
        return 'red'
      }
    },
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        '',
        this.data_secretaria_de_saude
      )
    },
    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.green {
  color: green;
}
.red {
  color: red;
}

@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
</style>
